<template>
  <div>
    <el-table
      class="table-list"
      ref="multipleTable"
      :data="dataList"
      border
      tooltip-effect="dark"
      style="width: 100%"
      @row-click="clickFn"
      @row-dblclick="dblclickFn"
      @selection-change="handleSelectionChange"
    >
      <el-table-column type="selection" width="55"></el-table-column>
      <el-table-column v-for="(th, index) in tableTh1" :key="index" :prop="th.name" :label="th.label" :width="th.width"></el-table-column>
      <el-table-column label="操作类型" width="100">
        <template slot-scope="scope">
          <span>{{oType[scope.row.operateType] ? oType[scope.row.operateType]:'后台'}}</span>
        </template>
      </el-table-column>
      <el-table-column v-for="(th, index) in tableTh2" :key="index" :prop="th.name" :label="th.label" :width="th.width" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column label="操作时间" width="200">
        <template slot-scope="scope">
          <span v-ftime="scope.row.operateTime"></span>
        </template>
      </el-table-column>
      <el-table-column label="操作结果" width="100">
        <template slot-scope="scope">
          <span>{{oResult[scope.row.operateResult]}}</span>
        </template>
      </el-table-column>
      <el-table-column v-for="(th, index) in tableTh3" :key="index" :prop="th.name" :label="th.label" :show-overflow-tooltip="true" :width="th.width"></el-table-column>
    </el-table>
  </div>
</template>
<script>
import TableRowClick from '@/mixins/tableRowClick.mixin';

const oType = {
  0: '登录',
  1: '查询',
  2: '新增',
  3: '修改',
  4: '删除',
  5: '打印',
  6: '导出',
  7: '启用',
  8: '停用',
  9: '审核'
};
const oResult = {
  0: '成功',
  1: '失败'
};

export default {
  name: 'list',
  props: {
    dataList: {
      type: Array
    }
  },
  mixins: [TableRowClick],
  data() {
    return {
      oType,
      oResult,
      tableTh1: [
        {
          name: 'userName',
          label: '用户名',
          width: '80'
        },
        {
          name: 'systemName',
          label: '应用系统名称',
          width: '250'
        },
        {
          name: 'depart',
          label: '用户机构',
          width: '200'
        },
        {
          name: 'depCode',
          label: '机构代码',
          width: '150'
        },
        {
          name: 'terminalId',
          label: '操作IP',
          width: '100'
        }
      ],
      tableTh2: [
        {
          name: 'functionModule',
          label: '模块名称',
          width: '150'
        },
        {
          name: 'content',
          label: '操作内容',
          width: '300'
        }
      ],
      tableTh3: [
        {
          name: 'errorCode',
          label: '失败原因代码',
          width: '150'
        },
        {
          name: 'operateCondition',
          label: '操作条件',
          width: '100'
        }
      ],
      bShowEditDialog: false
    };
  },
  methods: {
    handleSelectionChange(selectArrys) {
      for (let i = 0; i < this.dataList.length; i++) {
        let item = this.dataList[i];
        item.checked = false;
      }
      for (let i = 0; i < selectArrys.length; i++) {
        selectArrys[i].checked = true;
      }
    }
  }
};
</script>
<style lang="scss" scoped>
</style>
